export const AmplitudeWebMobileMode = {
  homescreen: 'pwa_homescreen',
  browser: 'pwa_browser',
};

export const Platform = {
  mobile: 'web_mobile',
  tablet: 'web_tablet',
  desktop: 'web_desktop',
};

export const PAGE_NAMES = Object.freeze({
  PHOTO_SESSIONS_LIST: 'PhotoSessionsList',
  PHOTO_SESSION_DETAIL: 'PhotoSessionDetail',
  CHECKLIST: 'Checklist',
  ISSUE_REPORT: 'IssueReport',
  RESCHEDULE: 'Reschedule',
  PROPERTY_ASSESSMENT: 'PropertyAssessment',
});
